import { Pipe } from '@angular/core';
import { OPTIONS } from '../../framework/constants/options-list.constants';
import { IPermissions } from '../../store/documents/documents.reducer';

import { BasePermissionsPipe } from './base-permissions.pipe';

@Pipe({
  name: 'optionPermissions',
  standalone: true,
})
export class OptionsPermissionsPipe extends BasePermissionsPipe {
  transform(item: Partial<IPermissions>): Array<OPTIONS> {
    const allPermissions: Array<OPTIONS> = [];
    const permissions = item as IPermissions;
    this.permissionLiteralToOptions.forEach((permissionLiteralOption) => {
      const option = this.findOption(permissionLiteralOption.value);
      const isPermissionAllowed = permissions[permissionLiteralOption.permission]; // will find specific permission 1 or 0
      if (isPermissionAllowed && option) {
        allPermissions.push(option.value);
      }
    });
    return allPermissions;
  }
}
